import React from 'react';
import ModalComponent from '../../../helpers_components/ModalComponent';
import { Button } from 'react-bootstrap';
import ElectronicSignatureTable from './componets/ElectronicSignatureTable';
import { useElectronicSignatureProcessContext } from './context/ElectronicSignatureProcessContext';

export default function CredentialsConfirmationModal({
  isModalShowing,
  onCloseModal,
  onCreatePkcs7,
  isReadyToCreatePkcs7,
  disableSignatureButton,
}) {
  const {
    electronicSignaturesList,
    isMultipleSignature,
    onDelteElectronicSignatureById,
    singleElectronicSignature,
  } = useElectronicSignatureProcessContext();

  return (
    <ModalComponent
      canClose
      onHide={onCloseModal}
      show={isModalShowing}
      header="Confirmación de Firma Electrónica"
      body={
        <div>
          <p>¿Está seguro de que desea firmar el documento electrónicamente?</p>
          <p>Esta acción no se puede deshacer.</p>

          {(Boolean(electronicSignaturesList.length && isMultipleSignature) ||
            (!isMultipleSignature && Boolean(singleElectronicSignature))) && (
            <>
              <p className="mt-3 mb-2">{isMultipleSignature ? 'Lista de Firmantes' : 'Firmante'}</p>
              <ElectronicSignatureTable
                electronicSignaturesList={electronicSignaturesList}
                singleElectronicSignature={singleElectronicSignature}
                isMultipleSignature={isMultipleSignature}
                onDelteElectronicSignatureById={onDelteElectronicSignatureById}
              />
            </>
          )}
        </div>
      }
      footer={
        <>
          <Button variant="secondary" onClick={onCloseModal}>
            {isMultipleSignature ? 'Agregar Firma' : 'Cambiar Firma'}
          </Button>
          <Button
            onClick={onCreatePkcs7}
            disabled={!isReadyToCreatePkcs7 || disableSignatureButton}
          >
            Firmar
          </Button>
        </>
      }
    />
  );
}
